/**
 * @generated SignedSource<<59437fc4d020cf4846ce5c0f5c942db8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name_en",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRouteTerminalsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Terminal",
        "kind": "LinkedField",
        "name": "terminals",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRouteTerminalsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Terminal",
        "kind": "LinkedField",
        "name": "terminals",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c44a80f840036c8cfcf262a78c1b7b55",
    "id": null,
    "metadata": {},
    "name": "useRouteTerminalsQuery",
    "operationKind": "query",
    "text": "query useRouteTerminalsQuery {\n  terminals {\n    internal_id\n    name\n    country {\n      internal_id\n      name\n      name_en\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "6011c39d08d8bcbef82f5b270209b733";

module.exports = node;
